<template>
<div class="commentary-dialog-root" style="display: contents;">
    <div
      v-if="inline"
      :class="contentClasses"
      data-testid="commentary-tabs-content"
    >
      <div class="d-flex align-center" data-testid="commentary-tabs-content__status-row">
        <div v-if="!bulksubmit" class="mb-2">
          <v-chip
            v-if="selectedcommentary.__stage === -1"
            :style="`background-color:${$nova.hexToRgbA($vuetify.theme.currentTheme.error, 0.1)}`"
            label
            data-testid="commentary-tabs-content__status-chip"
          >
            <v-icon color="error" class="mr-2">mdi-close-circle</v-icon>
            <span class="error--text font-weight-semibold">
              {{
                $nova.labelsName(
                  'cycle_page',
                  'commentary_filter_local_commentary_awaiting_approval',
                  'Local Commentary rejected'
                )
              }}
            </span>
          </v-chip>
          <v-chip
            v-else-if="selectedcommentary.__stage === 0"
            :style="`background-color:${$nova.hexToRgbA($vuetify.theme.currentTheme.info, 0.1)}`"
            label
            data-testid="commentary-tabs-content__status-chip"
          >
            <v-icon color="info" class="mr-2">mdi-timer-sand-full</v-icon>
            <span class="info--text font-weight-semibold">
              {{
                $nova.labelsName(
                  'cycle_page',
                  'commentary_filter_local_commentary_awaited',
                  'Local commentary awaited'
                )
              }}
            </span>
          </v-chip>
          <v-chip
            v-else-if="selectedcommentary.__stage === 1"
            :style="`background-color:${$nova.hexToRgbA($vuetify.theme.currentTheme.warning, 0.1)}`"
            label
            data-testid="commentary-tabs-content__status-chip"
          >
            <v-icon color="warning" class="mr-2">mdi-timer-sand-full</v-icon>
            <span class="warning--text font-weight-semibold">
              {{
                $nova.labelsName(
                  'cycle_page',
                  'commentary_filter_local_commentary_awaiting_approval',
                  'Local commentary awaiting approval'
                )
              }}
            </span>
          </v-chip>
          <v-chip
            v-else-if="selectedcommentary.__stage === -2"
            :style="`background-color:${$nova.hexToRgbA($vuetify.theme.currentTheme.error, 0.1)}`"
            label
            data-testid="commentary-tabs-content__status-chip"
          >
            <v-icon color="error" class="mr-2">mdi-close-circle-outline</v-icon>
            <span class="error--text font-weight-semibold">
              {{
                $nova.labelsName(
                  'cycle_page',
                  'commentary_filter_regional_commentary_rejected',
                  'Regional commentary rejected'
                )
              }}
            </span>
          </v-chip>
          <v-chip
            v-else-if="selectedcommentary.__stage === 5"
            :style="`background-color:${$nova.hexToRgbA($vuetify.theme.currentTheme.info, 0.1)}`"
            label
            data-testid="commentary-tabs-content__status-chip"
          >
            <v-icon color="info" class="mr-2">mdi-timer-sand-empty</v-icon>
            <span class="info--text font-weight-semibold">
              {{
                $nova.labelsName(
                  'cycle_page',
                  'commentary_filter_regional_commentary_awaited',
                  'Regional commentary awaited'
                )
              }}
            </span>
          </v-chip>
          <v-chip
            v-else-if="selectedcommentary.__stage === 6"
            :style="`background-color:${$nova.hexToRgbA($vuetify.theme.currentTheme.warning, 0.1)}`"
            label
            data-testid="commentary-tabs-content__status-chip"
          >
            <v-icon color="warning" class="mr-2">mdi-timer-sand-empty</v-icon>
            <span class="warning--text font-weight-semibold">
              {{
                $nova.labelsName(
                  'cycle_page',
                  'commentary_filter_regional_commentary_awaiting_approval',
                  'Regional Commentary awaiting approval'
                )
              }}
            </span>
          </v-chip>
          <v-chip
            v-else-if="selectedcommentary.__stage === 7"
            :style="`background-color:${$nova.hexToRgbA($vuetify.theme.currentTheme.success, 0.1)}`"
            label
            data-testid="commentary-tabs-content__status-chip"
          >
            <v-icon color="success" class="mr-2">mdi-check-circle</v-icon>
            <span class="success--text font-weight-semibold">Approved</span>
          </v-chip>
          <v-chip
            v-else-if="selectedcommentary.__stage === 3"
            :style="`background-color:${$nova.hexToRgbA($vuetify.theme.currentTheme.grey, 0.1)}`"
            label
            data-testid="commentary-tabs-content__status-chip"
          >
            <v-icon color="grey" class="mr-2">mdi-bookmark-off</v-icon>
            <span class="grey--text font-weight-semibold">
              {{
                $nova.labelsName(
                  'cycle_page',
                  'commentary_filter_nil_value_accounts_label',
                  'Nil value accounts'
                )
              }}
            </span>
          </v-chip>
          <v-chip
            v-else-if="selectedcommentary.__stage === 4"
            :style="`background-color:${$nova.hexToRgbA($vuetify.theme.currentTheme.grey, 0.1)}`"
            label
            data-testid="commentary-tabs-content__status-chip"
          >
            <v-icon color="grey" class="mr-2">mdi-cash-remove</v-icon>
            <span class="grey--text font-weight-semibold">
              {{
                $nova.labelsName(
                  'cycle_page',
                  'commentary_filter_immaterial_variance_label',
                  'Immaterial variance'
                )
              }}
            </span>
          </v-chip>
        </div>
        <v-spacer></v-spacer>
        
      </div>

      <template v-if="showInternalTabs">
        <v-tabs
          v-model="charttabModel"
          background-color="transparent"
          height="30"
          class="commentary-tabs-content__tabs"
          data-testid="commentary-tabs-content__tabs"
        >
          <v-tab key="0" data-testid="commentary-tabs-content__tab-commentary">Commentary</v-tab>
          <v-tab key="1" v-if="!bulksubmit" data-testid="commentary-tabs-content__tab-trendline">Trendline</v-tab>
          <v-tab key="2" v-if="shouldRenderSummaryTab" data-testid="commentary-tabs-content__tab-summary">Summary</v-tab>
        </v-tabs>
        <v-divider></v-divider>
      </template>

      <v-tabs-items v-model="charttabModel" data-testid="commentary-tabs-content__tab-items">
        <v-tab-item key="0" eager>
          <CommentaryMainTab
            :bulksubmit="bulksubmit"
            :bulktype="bulktype"
            :selectedcommentary="selectedcommentary"
            :multiselectdata="multiselectdata"
            :cycletype="cycletype"
            :commentary_local_key_label="commentary_local_key_label"
            :commentary_regional_key_label="commentary_regional_key_label"
            :workflowtext="workflowtext"
            :workflows="workflows"
            :tablecolors="tablecolors"
            :ispreparer="ispreparer"
            :isapprover="isapprover"
            :isregionalapprover="isregionalapprover"
            :cyclestage="cyclestage"
            :commentarySubmitDialogueViewMode="commentarySubmitDialogueViewMode"
            :localCommentaryGenAiBtntab="localCommentaryGenAiBtntab"
            :isRegionalCommentaryAutomationEnabled="isRegionalCommentaryAutomationEnabled"
            :isGlMandatoryRequestFlag="isGlMandatoryRequestFlag"
            :replaceExistingCommentFlag="replaceExistingCommentFlag"
            :lastActionsOnGL="lastActionsOnGL"
            :isTyping="isTyping"
            :loadingtext1="loadingtext1"
            :loadingtext2="loadingtext2"
            :isThresholdExceedLocalCommentary="isThresholdExceedLocalCommentary"
            :bulkcommentall="bulkcommentall"
            :bulkcommentreplace="bulkcommentreplace"
            :requestcommentarylocalcontrol="requestcommentarylocalcontrol"
            :requestcommentarylocalmanagement="requestcommentarylocalmanagement"
            :requestcommentaryregionalcontrol="requestcommentaryregionalcontrol"
            :requestcommentaryregionalmanagement="requestcommentaryregionalmanagement"
            :requestcommentarylocalcontrolvsProforma="requestcommentarylocalcontrolvsProforma"
            :requestcommentarylocalcontrolvsForecast="requestcommentarylocalcontrolvsForecast"
            :requestcommentarylocalmanagementvsProforma="requestcommentarylocalmanagementvsProforma"
            :requestcommentarylocalmanagementvsForecast="requestcommentarylocalmanagementvsForecast"
            :requestcommentaryregionalcontrolvsProforma="requestcommentaryregionalcontrolvsProforma"
            :requestcommentaryregionalmanagementvsProforma="requestcommentaryregionalmanagementvsProforma"
            :requestcommentaryregionalcontrolvsForecast="requestcommentaryregionalcontrolvsForecast"
            :requestcommentaryregionalmanagementvsForecast="requestcommentaryregionalmanagementvsForecast"
            :attachmentfile="attachmentfile"
            :attachmentfileloading="attachmentfileloading"
            :attachmentfilepercentage="attachmentfilepercentage"
            :isLocalCommentaryCollapsed="isLocalCommentaryCollapsed"
            :isLocalCommentaryReasonCollapsed="isLocalCommentaryReasonCollapsed"
            :actualLabel="actualLabel"
            :proformaLabel="proformaLabel"
            :forecastLabel="forecastLabel"
            :saveLocalCommentaryLoading="saveLocalCommentaryLoading"
            :saveLocalCommentaryField="saveLocalCommentaryField"
            :saveRegionalCommentaryLoading="saveRegionalCommentaryLoading"
            :saveRegionalCommentaryField="saveRegionalCommentaryField"
            :saveLocalReasonLoading="saveLocalReasonLoading"
            :saveRegionalReasonLoading="saveRegionalReasonLoading"
            :commentaryBaselines="commentaryBaselines"
            :commentaryBaselinesReady="commentaryBaselinesReady"
            @update:bulkcommentall="forward('update:bulkcommentall', $event)"
            @update:bulkcommentreplace="forward('update:bulkcommentreplace', $event)"
            @update:requestcommentarylocalcontrol="forward('update:requestcommentarylocalcontrol', $event)"
            @update:requestcommentarylocalmanagement="forward('update:requestcommentarylocalmanagement', $event)"
            @update:requestcommentaryregionalcontrol="forward('update:requestcommentaryregionalcontrol', $event)"
            @update:requestcommentaryregionalmanagement="forward('update:requestcommentaryregionalmanagement', $event)"
            @update:requestcommentarylocalcontrolvsProforma="forward('update:requestcommentarylocalcontrolvsProforma', $event)"
            @update:requestcommentarylocalcontrolvsForecast="forward('update:requestcommentarylocalcontrolvsForecast', $event)"
            @update:requestcommentarylocalmanagementvsProforma="forward('update:requestcommentarylocalmanagementvsProforma', $event)"
            @update:requestcommentarylocalmanagementvsForecast="forward('update:requestcommentarylocalmanagementvsForecast', $event)"
            @update:requestcommentaryregionalcontrolvsProforma="forward('update:requestcommentaryregionalcontrolvsProforma', $event)"
            @update:requestcommentaryregionalmanagementvsProforma="forward('update:requestcommentaryregionalmanagementvsProforma', $event)"
            @update:requestcommentaryregionalcontrolvsForecast="forward('update:requestcommentaryregionalcontrolvsForecast', $event)"
            @update:requestcommentaryregionalmanagementvsForecast="forward('update:requestcommentaryregionalmanagementvsForecast', $event)"
            @update:attachmentfile="forward('update:attachmentfile', $event)"
            @toggle-local-commentary-collapse="handleToggleLocalCommentaryCollapse"
            @toggle-local-commentary-reason-collapse="handleToggleLocalCommentaryReasonCollapse"
            @generate-ai="handleGenerateAi"
            @attachment-change="handleAttachmentChange"
            @save-local-commentary="field => forward('save-local-commentary', field)"
            @save-regional-commentary="field => forward('save-regional-commentary', field)"
            @save-local-reason="forward('save-local-reason')"
            @save-regional-reason="forward('save-regional-reason')"
            @commentary-display-ready="forward('commentary-display-ready')"
          />
        </v-tab-item>
        <v-tab-item key="1" eager v-if="!bulksubmit">
          <CommentaryTrendlineTab
            :bulksubmit="bulksubmit"
            :charttab="charttabModel"
            :cycletype="cycletype"
            :reportingType="reportingType"
            :trendYear="trendYear"
            :trendPeriod="trendPeriod"
            :trendReportingUnit="trendReportingUnit"
            :glContext="resolvedTrendlineContext"
            :selectedcommentary="selectedcommentary"
            :toggleview="toggleview"
            :actualLabel="actualLabel"
            :proformaLabel="proformaLabel"
            :forecastLabel="forecastLabel"
          />
        </v-tab-item>
        <v-tab-item key="2" eager v-if="shouldRenderSummaryTab">
          <CommentarySummaryTab
            :bulksubmit="bulksubmit"
            :selectedcommentary="selectedcommentary"
            :tablecolors="tablecolors"
            :cycletype="cycletype"
            :bulktype="bulktype"
            :summaryAiProforma="summaryAiProforma"
            :summaryAiForecast="summaryAiForecast"
            :aitext="aitext"
            :loadingtext1="loadingtext1"
            :loadingtext2="loadingtext2"
            :isTyping="isTyping"
            :isThresholdExceedJVSummarisation="isThresholdExceedJVSummarisation"
            :showSummaryTab="showSummaryTab"
            :forceSummaryTab="forceSummaryTab"
            :ispreparer="ispreparer"
            :actualLabel="actualLabel"
            :proformaLabel="proformaLabel"
            :forecastLabel="forecastLabel"
            @update:summaryAiProforma="forward('update:summaryAiProforma', $event)"
            @update:summaryAiForecast="forward('update:summaryAiForecast', $event)"
            @update:aitext="forward('update:aitext', $event)"
            @generate-ai-summary="handleGenerateAiSummary"
          />
        </v-tab-item>
      </v-tabs-items>
    </div>
    <lb-dialog
      v-else
      v-model="internalValue"
      :heading="dialogHeading"
      width="55%"
      :loading="loading"
    >
      <template v-slot:body>
        <div :class="contentClasses" data-testid="commentary-tabs-content" class="d-flex flex-column gap-3">
          <v-card v-if="!bulksubmit && showSummaryCard" class="pa-3" outlined data-testid="commentary-dialog__header-card">
            <div class="d-flex align-center flex-wrap gap-4">
              <div v-if="selectedcommentary.__code || glCodeName" class="summary-card__subtitle">
                {{selectedcommentary.__code}} - {{ glCodeName }}
              </div>
              <!-- Status Indicator - using StatusIndicator component like Breadcrumbs -->
              <StatusIndicator
                v-if="statusVariant"
                :variant="statusVariant"
                size="sm"
                outlined
                style="width: auto;"
                data-testid="commentary-dialog__status-pill"
                cornerRadius="8px"
              />
            </div>
          </v-card>
          <!-- Summary Card Section - Matching drill-down dialog design -->
          <section
            v-if="!bulksubmit && showSummaryCard"
            class="summary-card d-flex flex-column gap-3"
            data-testid="commentary-dialog__summary-card"
          >
            <div
              class="summary-card__header"
              role="button"
              tabindex="0"
              :aria-expanded="isSummaryExpanded.toString()"
              aria-controls="commentary-dialog__summary-content"
              data-testid="commentary-dialog__summary-toggle"
              @click="isSummaryExpanded = !isSummaryExpanded"
              @keyup.enter.prevent="isSummaryExpanded = !isSummaryExpanded"
              @keyup.space.prevent="isSummaryExpanded = !isSummaryExpanded"
            >
              <div class="d-flex flex-column gap-2">
                <h4 class="summary-card__title">Variance analysis summary</h4>
              </div>
              <div class="d-flex align-center gap-2">
                <v-icon small :class="['summary-toggle-icon', { 'is-expanded': isSummaryExpanded }]">
                  {{ isSummaryExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
              </div>
            </div>
            <v-expand-transition>
              <div
                v-if="isSummaryExpanded"
                class="summary-card__body d-flex flex-column gap-3"
                id="commentary-dialog__summary-content"
                data-testid="commentary-dialog__summary-content"
              >
                <v-divider></v-divider>
                <div class="summary-grid">
                  <div class="summary-panel">
                    <div class="d-flex align-center gap-2">
                      <h5 class="summary-panel__title">
                        {{ cycletype === 'Forecast' ? forecastLabel : actualLabel }} Vs {{ proformaLabel }}
                      </h5>
                      <!-- Threshold Flags for Vs Proforma -->
                      <div class="d-flex" v-if="selectedcommentary.var1_cross_control || selectedcommentary.var1_cross_management || selectedcommentary.var1_cross_control_regional || selectedcommentary.var1_cross_management_regional">
                        <v-tooltip bottom v-if="selectedcommentary.var1_cross_control">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" style="font-size:12px !important;" class="error--text mr-1">mdi-circle</v-icon>
                          </template>
                          <span>{{ commentary_local_key_label + ' Control Materiality crossed' }}</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="selectedcommentary.var1_cross_management">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" style="font-size:12px !important;" class="blue--text mr-1">mdi-circle</v-icon>
                          </template>
                          <span>{{ commentary_local_key_label + ' Management Materiality crossed' }}</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="selectedcommentary.var1_cross_control_regional">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" style="font-size:12px !important;" class="error--text mr-1">mdi-record-circle-outline</v-icon>
                          </template>
                          <span>{{ commentary_regional_key_label + ' Control Materiality crossed' }}</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="selectedcommentary.var1_cross_management_regional">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" style="font-size:12px !important;" class="blue--text mr-1">mdi-record-circle-outline</v-icon>
                          </template>
                          <span>{{ commentary_regional_key_label + ' Management Materiality crossed' }}</span>
                        </v-tooltip>
                      </div>
                    </div>
                    <div class="d-flex gap-6 flex-wrap actual-card">
                      <div class="d-flex flex-column gap-2">
                        <div class="grey-title">{{ cycletype === 'Forecast' ? forecastLabel : actualLabel }}</div>
                        <div class="font-size-md">{{ formatCurrency(selectedcommentary.amount1) }}</div>
                      </div>
                      <div class="d-flex flex-column gap-2">
                        <div class="grey-title">{{ proformaLabel }}</div>
                        <div class="font-size-md">{{ formatCurrency(selectedcommentary.amount2) }}</div>
                      </div>
                      <div class="d-flex flex-column gap-2">
                        <div class="grey-title">Variance Amt</div>
                        <div :class="varianceClass(selectedcommentary.varianceamount1)">{{ formatCurrency(selectedcommentary.varianceamount1) }}</div>
                      </div>
                      <div class="d-flex flex-column gap-2">
                        <div class="grey-title">Variance %</div>
                        <div :class="varianceClass(selectedcommentary.varianceamount1)">{{ formatPercent(selectedcommentary.variancepercent1) }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="summary-panel">
                    <div class="d-flex align-center gap-2">
                      <h5 class="summary-panel__title">
                        {{ cycletype === 'Forecast' ? forecastLabel : actualLabel }} Vs {{ cycletype === 'Forecast' ? 'Previous ' + forecastLabel : forecastLabel }}
                      </h5>
                      <!-- Threshold Flags for Vs Forecast -->
                      <div class="d-flex" v-if="selectedcommentary.var2_cross_control || selectedcommentary.var2_cross_management || selectedcommentary.var2_cross_control_regional || selectedcommentary.var2_cross_management_regional">
                        <v-tooltip bottom v-if="selectedcommentary.var2_cross_control">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" style="font-size:12px !important;" class="error--text mr-1">mdi-circle</v-icon>
                          </template>
                          <span>{{ commentary_local_key_label + ' Control Materiality crossed' }}</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="selectedcommentary.var2_cross_management">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" style="font-size:12px !important;" class="blue--text mr-1">mdi-circle</v-icon>
                          </template>
                          <span>{{ commentary_local_key_label + ' Management Materiality crossed' }}</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="selectedcommentary.var2_cross_control_regional">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" style="font-size:12px !important;" class="error--text mr-1">mdi-record-circle-outline</v-icon>
                          </template>
                          <span>{{ commentary_regional_key_label + ' Control Materiality crossed' }}</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="selectedcommentary.var2_cross_management_regional">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" style="font-size:12px !important;" class="blue--text mr-1">mdi-record-circle-outline</v-icon>
                          </template>
                          <span>{{ commentary_regional_key_label + ' Management Materiality crossed' }}</span>
                        </v-tooltip>
                      </div>
                    </div>
                    <div class="d-flex gap-6 flex-wrap actual-card">
                      <div class="d-flex flex-column gap-2">
                        <div class="grey-title">{{ cycletype === 'Forecast' ? forecastLabel : actualLabel }}</div>
                        <div class="font-size-md">{{ formatCurrency(selectedcommentary.amount1) }}</div>
                      </div>
                      <div class="d-flex flex-column gap-2">
                        <div class="grey-title">{{ cycletype === 'Forecast' ? 'Previous ' + forecastLabel : forecastLabel }}</div>
                        <div class="font-size-md">{{ formatCurrency(selectedcommentary.amount3) }}</div>
                      </div>
                      <div class="d-flex flex-column gap-2">
                        <div class="grey-title">Variance Amt</div>
                        <div :class="varianceClass(selectedcommentary.varianceamount2)">{{ formatCurrency(selectedcommentary.varianceamount2) }}</div>
                      </div>
                      <div class="d-flex flex-column gap-2">
                        <div class="grey-title">Variance %</div>
                        <div :class="varianceClass(selectedcommentary.varianceamount2)">{{ formatPercent(selectedcommentary.variancepercent2) }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-expand-transition>
          </section>

          <!-- Commentary Content Card - Single tab content without tabs -->
          <v-card elevation="1" class="commentary-content-card pa-4">
            <CommentaryMainTab
                :bulksubmit="bulksubmit"
                :bulktype="bulktype"
                :selectedcommentary="selectedcommentary"
                :multiselectdata="multiselectdata"
                :cycletype="cycletype"
                :commentary_local_key_label="commentary_local_key_label"
                :commentary_regional_key_label="commentary_regional_key_label"
                :workflowtext="workflowtext"
                :workflows="workflows"
                :tablecolors="tablecolors"
                :ispreparer="ispreparer"
                :isapprover="isapprover"
                :isregionalapprover="isregionalapprover"
                :cyclestage="cyclestage"
                :commentarySubmitDialogueViewMode="commentarySubmitDialogueViewMode"
                :localCommentaryGenAiBtntab="localCommentaryGenAiBtntab"
                :isRegionalCommentaryAutomationEnabled="isRegionalCommentaryAutomationEnabled"
                :isGlMandatoryRequestFlag="isGlMandatoryRequestFlag"
                :replaceExistingCommentFlag="replaceExistingCommentFlag"
                :lastActionsOnGL="lastActionsOnGL"
                :isTyping="isTyping"
                :loadingtext1="loadingtext1"
                :loadingtext2="loadingtext2"
                :isThresholdExceedLocalCommentary="isThresholdExceedLocalCommentary"
                :bulkcommentall="bulkcommentall"
                :bulkcommentreplace="bulkcommentreplace"
                :requestcommentarylocalcontrol="requestcommentarylocalcontrol"
                :requestcommentarylocalmanagement="requestcommentarylocalmanagement"
                :requestcommentaryregionalcontrol="requestcommentaryregionalcontrol"
                :requestcommentaryregionalmanagement="requestcommentaryregionalmanagement"
                :requestcommentarylocalcontrolvsProforma="requestcommentarylocalcontrolvsProforma"
                :requestcommentarylocalcontrolvsForecast="requestcommentarylocalcontrolvsForecast"
                :requestcommentarylocalmanagementvsProforma="requestcommentarylocalmanagementvsProforma"
                :requestcommentarylocalmanagementvsForecast="requestcommentarylocalmanagementvsForecast"
                :requestcommentaryregionalcontrolvsProforma="requestcommentaryregionalcontrolvsProforma"
                :requestcommentaryregionalmanagementvsProforma="requestcommentaryregionalmanagementvsProforma"
                :requestcommentaryregionalcontrolvsForecast="requestcommentaryregionalcontrolvsForecast"
                :requestcommentaryregionalmanagementvsForecast="requestcommentaryregionalmanagementvsForecast"
                :attachmentfile="attachmentfile"
                :attachmentfileloading="attachmentfileloading"
                :attachmentfilepercentage="attachmentfilepercentage"
                :isLocalCommentaryCollapsed="isLocalCommentaryCollapsed"
                :isLocalCommentaryReasonCollapsed="isLocalCommentaryReasonCollapsed"
                :hideSummarySection="true"
                :actualLabel="actualLabel"
                :proformaLabel="proformaLabel"
                :forecastLabel="forecastLabel"
                :saveLocalCommentaryLoading="saveLocalCommentaryLoading"
                :saveLocalCommentaryField="saveLocalCommentaryField"
                :saveRegionalCommentaryLoading="saveRegionalCommentaryLoading"
                :saveRegionalCommentaryField="saveRegionalCommentaryField"
                :saveLocalReasonLoading="saveLocalReasonLoading"
                :saveRegionalReasonLoading="saveRegionalReasonLoading"
                :commentaryBaselines="commentaryBaselines"
                :commentaryBaselinesReady="commentaryBaselinesReady"
                @update:bulkcommentall="forward('update:bulkcommentall', $event)"
                @update:bulkcommentreplace="forward('update:bulkcommentreplace', $event)"
                @update:requestcommentarylocalcontrol="forward('update:requestcommentarylocalcontrol', $event)"
                @update:requestcommentarylocalmanagement="forward('update:requestcommentarylocalmanagement', $event)"
                @update:requestcommentaryregionalcontrol="forward('update:requestcommentaryregionalcontrol', $event)"
                @update:requestcommentaryregionalmanagement="forward('update:requestcommentaryregionalmanagement', $event)"
                @update:requestcommentarylocalcontrolvsProforma="forward('update:requestcommentarylocalcontrolvsProforma', $event)"
                @update:requestcommentarylocalcontrolvsForecast="forward('update:requestcommentarylocalcontrolvsForecast', $event)"
                @update:requestcommentarylocalmanagementvsProforma="forward('update:requestcommentarylocalmanagementvsProforma', $event)"
                @update:requestcommentarylocalmanagementvsForecast="forward('update:requestcommentarylocalmanagementvsForecast', $event)"
                @update:requestcommentaryregionalcontrolvsProforma="forward('update:requestcommentaryregionalcontrolvsProforma', $event)"
                @update:requestcommentaryregionalmanagementvsProforma="forward('update:requestcommentaryregionalmanagementvsProforma', $event)"
                @update:requestcommentaryregionalcontrolvsForecast="forward('update:requestcommentaryregionalcontrolvsForecast', $event)"
                @update:requestcommentaryregionalmanagementvsForecast="forward('update:requestcommentaryregionalmanagementvsForecast', $event)"
                @update:attachmentfile="forward('update:attachmentfile', $event)"
                @toggle-local-commentary-collapse="handleToggleLocalCommentaryCollapse"
                @toggle-local-commentary-reason-collapse="handleToggleLocalCommentaryReasonCollapse"
                @generate-ai="handleGenerateAi"
                @attachment-change="handleAttachmentChange"
                @save-local-commentary="field => forward('save-local-commentary', field)"
                @save-regional-commentary="field => forward('save-regional-commentary', field)"
                @save-local-reason="forward('save-local-reason')"
                @save-regional-reason="forward('save-regional-reason')"
                @commentary-display-ready="forward('commentary-display-ready')"
              />
          </v-card>
        </div>
      </template>
      <template v-if="commentarySubmitDialogueViewMode !== true" v-slot:actions>
        <div v-if="replaceExistingCommentFlag">
          <span class="font-weight-semibold">Note:</span>
          <span class="ml-1 noTransform">For GL's with existing comments, it is replaced only if the checkbox above is selected.</span>
        </div>
        <v-spacer></v-spacer>
        <div
          v-if="sodEnabled && selectedcommentary.__myaction === 'localapprove' && selectedcommentary.localsubmitby === userid"
          class="error--text"
        >
          {{ $nova.labelsName('cycle_page', 'commentary_local_preparer_label', 'Local Preparer') }} and the
          {{ $nova.labelsName('cycle_page', 'commentary_local_approver_label', 'Local Approver') }} cannot be same person.
        </div>
        <div
          v-else-if="
            sodEnabled &&
            (selectedcommentary.__myaction === 'regionalapprove' || isregionalapprover) &&
            selectedcommentary.regionalsubmitby === userid
          "
          class="error--text"
        >
          Regional Preparer and the
          {{ $nova.labelsName('cycle_page', 'commentary_regional_approver_label', 'Regional Approver') }} cannot be same
          person.
        </div>
        <div
          v-if="
            selectedcommentary.__myaction === 'localapprove' ||
            (selectedcommentary.__myaction === 'regionalapprove' || isregionalapprover) ||
            (isapprover && bulksubmit) ||
            toggleview === 3
          "
          class="d-flex gap-2"
        >
          <v-btn
            v-if="isRegionalCommentaryAutomationEnabled && isapprover"
            class=""
            @click="handleApproveCommentary"
            color="primary"
          >
            <span>{{ $nova.labelsName('cycle_page', 'commentary_approve_submit_label', 'Approve and Submit') }}</span>
          </v-btn>
          <v-btn v-else class="primary" @click="handleApproveCommentary" color="primary">
            <span>{{ $nova.labelsName('cycle_page', 'commentary_approve_label', 'Approve') }}</span>
          </v-btn>
          <!-- Reject button with target selection menu for regional approvers -->
          <v-menu 
            data-testid="commentary-dialog__reject-menu" 
            offset-y 
            v-model="rejectCommentaryMenu" 
            :close-on-content-click="false" 
            transition="slide-y-transition" 
            v-if="isregionalapprover"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                data-testid="commentary-dialog__reject-button-regional" 
                v-bind="attrs" 
                v-on="on" 
                class="rejectBtn"
              >
                <v-icon data-testid="commentary-dialog__reject-button-icon" left small>mdi-close-circle-outline</v-icon>
                <span>{{ $nova.labelsName('cycle_page', 'commentary_rejecte_label', 'Reject') }}</span>
                <v-icon data-testid="commentary-dialog__reject-button-chevron" right small>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-card data-testid="commentary-dialog__reject-menu-card" min-width="200" class="elevation-8 rounded-lg">
              <div data-testid="commentary-dialog__reject-menu-header" class="pa-3 error lighten-5">
                <div class="d-flex align-center">
                  <v-icon data-testid="commentary-dialog__reject-menu-header-icon" color="error" class="mr-2">mdi-alert-circle</v-icon>
                  <span data-testid="commentary-dialog__reject-menu-header-title" class="font-weight-bold error--text">Select Rejection Target</span>
                </div>
              </div>
              <v-divider></v-divider>
              <v-list data-testid="commentary-dialog__reject-target-list" dense class="py-1">
                <v-list-item 
                  :data-testid="`commentary-dialog__reject-target-item-${index}`"
                  v-for="(target, index) in rejectTargetList" 
                  :key="index"
                  @click="handleRejectWithTarget(target._id)"
                  class="cursor-pointer rejection-target-item mx-2 my-1 rounded"
                >
                  <v-list-item-icon class="mr-3 my-auto">
                    <v-icon data-testid="commentary-dialog__reject-target-item-icon" color="error lighten-1" small>mdi-account-arrow-left</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title data-testid="commentary-dialog__reject-target-item-name" class="subtitle-2 font-weight-medium">{{ target.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
          <!-- Simple reject button for non-regional approvers -->
          <v-btn 
            data-testid="commentary-dialog__reject-button-simple" 
            v-else 
            @click="handleRejectCommentary" 
            class="rejectBtn" 
            color=""
          >
            <span>{{ $nova.labelsName('cycle_page', 'commentary_rejecte_label', 'Reject') }}</span>
          </v-btn>
        </div>

        <template
          v-if="
            selectedcommentary.__myaction === 'localadd' ||
            selectedcommentary.__myaction === 'regionaladd' ||
            selectedcommentary.__myaction === 'localvoluntary' ||
            selectedcommentary.__myaction === 'regionalvoluntary' ||
            (ispreparer && bulksubmit)
          "
        >
          <div v-if="charttabModel !== 1">
            <v-btn
              v-if="!bulksubmit && ispreparer && !showPerFieldLocalSave"
              @click="handleSaveCommentary"
              class="mr-1 secondaryBtn"
              :disabled="!workflows.lcp && !workflows.lmp && !workflows.lcf && !workflows.lmf"
            >
              <span>Save</span>
            </v-btn>
          </div>
          <v-btn
            v-if="charttabModel !== 1 && charttabModel !== 2"
            @click="handleAddCommentary"
            color="primary"
            :disabled="
              (isapprover && !workflows.rcp && !workflows.rmp && !workflows.rcf && !workflows.rmf) ||
              (ispreparer && !workflows.lcp && !workflows.lmp && !workflows.lcf && !workflows.lmf)
            "
          >
            <span>Submit</span>
          </v-btn>
        </template>
      </template>
    </lb-dialog>
  </div>
</template>

<script>
import CommentaryMainTab from '../components/commentary/CommentaryMainTab.vue';
import CommentaryTrendlineTab from '../components/commentary/CommentaryTrendlineTab.vue';
import CommentarySummaryTab from '../components/commentary/CommentarySummaryTab.vue';
import StatusIndicator from '../components/StatusIndicator.vue';
import { COMMENTARY_STAGE_VARIANT_MAP, COMMENTARY_STAGE_LABEL_MAP } from '../utils/statusConstants';

export default {
  name: 'CommentaryDialog',
  components: {
    CommentaryMainTab,
    CommentaryTrendlineTab,
    CommentarySummaryTab,
    StatusIndicator,
  },
  data() {
    return {
      // Reject target menu state
      rejectCommentaryMenu: false,
      // Summary card expanded state
      isSummaryExpanded: true,
    };
  },
  props: {
    value: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    bulksubmit: { type: Boolean, default: false },
    bulktype: { type: String, default: '' },
    bulkcommentall: { type: Boolean, default: false },
    bulkcommentreplace: { type: Boolean, default: false },
    selectedcommentary: { type: Object, default: () => ({}) },
    multiselectdata: { type: Array, default: () => [] },
    tablecolors: {
      type: Object,
      default: () => ({ heading: { a: '', b: '' }, body: { a: '', b: '' } }),
    },
    cycletype: { type: String, default: '' },
    cycletypeReadview: { type: String, default: 'Proforma' },
    ispreparer: { type: Boolean, default: false },
    isapprover: { type: Boolean, default: false },
    isregionalapprover: { type: Boolean, default: false },
    userid: { type: [String, Number], default: '' },
    sodEnabled: { type: Boolean, default: true },
    // Reject target list for regional approvers
    rejectTargetList: { type: Array, default: () => [] },
    workflowtext: { type: Array, default: () => [] },
    workflows: { type: Object, default: () => ({}) },
    cyclestage: { type: Number, default: 0 },
    commentary_local_key_label: { type: String, default: 'Local' },
    commentary_regional_key_label: { type: String, default: 'Regional' },
    aggregatedLabelText: { type: String, default: 'Regional' },
    localCommentaryGenAiBtntab: { type: Boolean, default: false },
    isRegionalCommentaryAutomationEnabled: { type: Boolean, default: false },
    isLocalCommentaryCollapsed: { type: Boolean, default: false },
    isLocalCommentaryReasonCollapsed: { type: Boolean, default: false },
    isGlMandatoryRequestFlag: { type: Boolean, default: false },
    replaceExistingCommentFlag: { type: Boolean, default: false },
    charttab: { type: Number, default: 0 },
    commentarySubmitDialogueViewMode: { type: Boolean, default: false },
    toggleview: { type: Number, default: 0 },
    reportingType: { type: String, default: '' },
    trendYear: { type: [String, Number], default: '' },
    trendPeriod: { type: [String, Number], default: '' },
    trendReportingUnit: { type: [String, Number], default: '' },
    trendlineGlContext: { type: Object, default: () => ({}) },
    lastActionsOnGL: { type: Object, default: () => ({}) },
    attachmentfile: { type: [File, Object, String, null], default: null },
    attachmentfileloading: { type: Boolean, default: false },
    attachmentfilepercentage: { type: Number, default: 0 },
    downloadAttachmentUrlBase: { type: String, default: '/v2/varianceanalysis/analysis/downloadattachment/' },
    isTyping: { type: Boolean, default: false },
    loadingtext1: { type: Boolean, default: false },
    loadingtext2: { type: Boolean, default: false },
    isThresholdExceedLocalCommentary: { type: Boolean, default: false },
    isThresholdExceedJVSummarisation: { type: Boolean, default: false },
    showSummaryTab: { type: Boolean, default: false },
    summaryAiProforma: { type: String, default: '' },
    summaryAiForecast: { type: String, default: '' },
    aitext: { type: String, default: '' },
    requestcommentarylocalcontrol: { type: Boolean, default: false },
    requestcommentarylocalmanagement: { type: Boolean, default: false },
    requestcommentaryregionalcontrol: { type: Boolean, default: false },
    requestcommentaryregionalmanagement: { type: Boolean, default: false },
    requestcommentarylocalcontrolvsProforma: { type: Boolean, default: false },
    requestcommentarylocalcontrolvsForecast: { type: Boolean, default: false },
    requestcommentarylocalmanagementvsProforma: { type: Boolean, default: false },
    requestcommentarylocalmanagementvsForecast: { type: Boolean, default: false },
    requestcommentaryregionalcontrolvsProforma: { type: Boolean, default: false },
    requestcommentaryregionalmanagementvsProforma: { type: Boolean, default: false },
    requestcommentaryregionalcontrolvsForecast: { type: Boolean, default: false },
    requestcommentaryregionalmanagementvsForecast: { type: Boolean, default: false },
    inline: { type: Boolean, default: false },
    forceSummaryTab: { type: Boolean, default: false },
    showInternalTabs: { type: Boolean, default: true },
    hideTrendLine: { type: Boolean, default: false },
    /** Commentary type/action mode - 'view', 'addlocal', 'addregional', 'approvelocal', 'approveregional' */
    commentarytype: { type: String, default: '' },
    actualLabel: { type: String, default: 'Actual' },
    proformaLabel: { type: String, default: 'Proforma' },
    forecastLabel: { type: String, default: 'Forecast' },
    saveLocalCommentaryLoading: { type: Boolean, default: false },
    saveLocalCommentaryField: { type: String, default: '' },
    saveRegionalCommentaryLoading: { type: Boolean, default: false },
    saveRegionalCommentaryField: { type: String, default: '' },
    saveLocalReasonLoading: { type: Boolean, default: false },
    saveRegionalReasonLoading: { type: Boolean, default: false },
    commentaryBaselines: { type: Object, default: () => ({}) },
    commentaryBaselinesReady: { type: Boolean, default: false },
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    charttabModel: {
      get() {
        return this.charttab;
      },
      set(val) {
        this.$emit('update:charttab', val);
      },
    },
    // Dialog heading based on action type
    dialogHeading() {
      if (this.bulksubmit) {
        // For bulk approve/reject, show specific heading
        if (['approvelocal', 'approveregional'].includes(this.bulktype)) {
          return 'Bulk Approve/Reject';
        }
        return 'Bulk Commentary';
      }
      // Determine heading based on commentarytype
      const mode = this.commentarytype || '';
      if (mode === 'view') {
        return 'View Commentary';
      }
      if (['addlocal', 'addregional', 'localadd', 'regionaladd', 'localvoluntary', 'regionalvoluntary'].includes(mode)) {
        return 'Add Commentary';
      }
      if (['approvelocal', 'approveregional', 'localapprove', 'regionalapprove'].includes(mode)) {
        return 'Approve Commentary';
      }
      // Fallback to action-based heading
      const action = this.selectedcommentary?.__myaction || '';
      if (action === 'view' || this.commentarySubmitDialogueViewMode) {
        return 'View Commentary';
      }
      if (['localadd', 'regionaladd', 'localvoluntary', 'regionalvoluntary'].includes(action)) {
        return 'Add Commentary';
      }
      if (['localapprove', 'regionalapprove'].includes(action)) {
        return 'Approve Commentary';
      }
      return 'Commentary';
    },
    // Show summary card for non-bulk single commentary view
    showSummaryCard() {
      return this.selectedcommentary && 
             Object.keys(this.selectedcommentary).length > 0 &&
             (this.selectedcommentary.amount1 !== undefined || this.selectedcommentary.amount2 !== undefined);
    },
    contentClasses() {
      return {
        'commentary-tabs-content': true,
        'commentary-tabs-content--inline': this.inline,
      };
    },
    resolvedTrendlineContext() {
      const base = this.selectedcommentary || {};
      const sanitized = this.trendlineGlContext && Object.keys(this.trendlineGlContext).length > 0 ? this.trendlineGlContext : {};
      const merged = { ...base, ...sanitized };
      if (this.reportingType && !merged.reporting_type) {
        merged.reporting_type = this.reportingType;
      }
      return merged;
    },
    glCodeName() {
      return (
        (this.selectedcommentary &&
          this.selectedcommentary.glcode_detail &&
          this.selectedcommentary.glcode_detail.name) ||
        ''
      );
    },
    shouldRenderSummaryTab() {
      if (this.bulksubmit) {
        return false;
      }
      const baseCondition =
        this.$store.state.aiEnabled &&
        this.showSummaryTab &&
        (this.isActualJVCommentaryValidForLocal(this.selectedcommentary) ||
          this.isForecastJVCommentaryValidForLocal(this.selectedcommentary));
      return this.forceSummaryTab || baseCondition;
    },
    /**
     * Get the stage value from the selected commentary
     */
    stage() {
      return this.selectedcommentary && typeof this.selectedcommentary.__stage === 'number'
        ? this.selectedcommentary.__stage
        : null;
    },
    /**
     * Get the status variant for StatusIndicator component
     */
    statusVariant() {
      if (this.bulksubmit || this.stage === null) {
        return null;
      }
      return COMMENTARY_STAGE_VARIANT_MAP[String(this.stage)] || null;
    },
    /**
     * Get the status label for StatusIndicator component
     */
    statusLabel() {
      if (this.bulksubmit || this.stage === null) {
        return '';
      }
      const config = COMMENTARY_STAGE_LABEL_MAP[String(this.stage)];
      if (config) {
        return this.$nova?.labelsName?.(config.labelNamespace || 'cycle_page', config.labelKey, config.fallback) || config.fallback;
      }
      return '';
    },
    /**
     * Check if the commentary is saved (both commentary fields match saved state)
     */
    isSaved() {
      const normalize = (value) => String(value ?? '').trim();
      return normalize(this.selectedcommentary.savedcommentary1) === normalize(this.selectedcommentary.commentary1) &&
             normalize(this.selectedcommentary.savedcommentary2) === normalize(this.selectedcommentary.commentary2);
    },
    showPerFieldLocalSave() {
      return (
        this.ispreparer &&
        !this.bulksubmit &&
        (this.selectedcommentary.__myaction === 'localadd' ||
          this.selectedcommentary.__myaction === 'localvoluntary') &&
        this.selectedcommentary.__stage !== 9
      );
    },
  },
  watch: {
    bulksubmit(val) {
      if (val && this.charttabModel !== 0) {
        this.charttabModel = 0;
      }
    },
    shouldRenderSummaryTab(val) {
      if (!val && this.charttabModel === 2) {
        this.charttabModel = 0;
      }
    },
  },
  methods: {
    forward(eventName, payload) {
      this.$emit(eventName, payload);
    },
    handleToggleLocalCommentaryCollapse() {
      this.$emit('toggle-local-commentary-collapse');
    },
    handleToggleLocalCommentaryReasonCollapse() {
      this.$emit('toggle-local-commentary-reason-collapse');
    },
    handleGenerateAi(payload) {
      this.$emit('generate-ai', payload);
    },
    handleGenerateAiSummary(payload) {
      this.$emit('generate-ai-summary', payload);
    },
    handleAttachmentChange() {
      this.$emit('attachment-change', this.selectedcommentary?._id);
    },
    handleDownloadAttachment() {
      const base = (this.downloadAttachmentUrlBase || '/v2/varianceanalysis/analysis/downloadattachment/').trim();
      const normalizedBase = base.endsWith('/') ? base : `${base}/`;
      const commentaryId = this.selectedcommentary && this.selectedcommentary._id;
      if (!commentaryId) return;

      this.$nova.downloadFile(
        undefined,
        {},
        `${normalizedBase}${commentaryId}/t/${this.cycletype}`,
        `&uploadid=${this.selectedcommentary.upload}&timestamp=${new Date().getTime()}`
      );
    },
    handleApproveCommentary() {
      this.$emit('approve-commentary');
    },
    handleRejectCommentary() {
      this.$emit('reject-commentary');
    },
    /**
     * Handle reject with target selection for regional approvers
     * @param {string} targetId - The rejection target ('local_approver' or 'local_preparer')
     */
    handleRejectWithTarget(targetId) {
      this.rejectCommentaryMenu = false;
      this.$emit('reject-commentary', targetId);
    },
    handleSaveCommentary() {
      this.$emit('save-commentary');
    },
    handleAddCommentary() {
      this.$emit('add-commentary');
    },
    isActualJVCommentaryValidForLocal() {
      return true;
    },
    isForecastJVCommentaryValidForLocal() {
      return true;
    },
    // Helper methods matching drill-down dialog
    formatCurrency(amount) {
      if (amount === null || amount === undefined || amount === '') {
        return '-';
      }
      if (this.$nova && typeof this.$nova.formatCurrency === 'function') {
        return this.$nova.formatCurrency(amount, '', false, true);
      }
      const numericValue = Number(amount);
      return Number.isNaN(numericValue) ? '-' : numericValue.toLocaleString();
    },
    formatPercent(value) {
      if (value === null || value === undefined || value === '') {
        return '-';
      }
      const percent = Number(value);
      if (Number.isNaN(percent)) {
        return '-';
      }
      if (this.$nova && typeof this.$nova.formatCurrency === 'function') {
        const formatted = this.$nova.formatCurrency(percent, '', false, true);
        return `${formatted}${percent !== 0 ? ' %' : ''}`;
      }
      return `${percent.toFixed(1)}${percent !== 0 ? '%' : ''}`;
    },
    varianceClass(value) {
      if (value > 0) {
        return 'success--text font-weight-bold';
      }
      if (value < 0) {
        return 'error--text font-weight-bold';
      }
      return 'grey--text font-weight-bold';
    },
  },
  beforeDestroy() {
    this.$emit('update:charttab', 0);
  },
};
</script>

<style scoped>
.commentary-tabs-content--inline {
  background: #fff;
  border-radius: 8px;
}

/* Summary Card Styles - matching drill-down dialog */
.summary-card {
  background: #ffffff;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #f7f7f7;
  box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.08);
}

.summary-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.summary-card__header:focus {
  outline: none;
}

.summary-card__header:focus-visible {
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.4);
  border-radius: 8px;
}

.summary-card__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2C2C35;
}

.summary-card__subtitle {
  font-size: 18px;
  font-weight: 600;
  color: #2C2C35;
}

.summary-card__body {
  width: 100%;
}

.summary-toggle-icon {
  transition: transform 0.2s ease-in-out;
}

.summary-toggle-icon.is-expanded {
  transform: rotate(180deg);
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
}

.summary-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.summary-panel__title {
  margin: 0;
  font-weight: 600;
  color: #1f2937;
}

.gap-2 {
  gap: 8px;
}

.gap-3 {
  gap: 12px;
}

.gap-4 {
  gap: 16px;
}

.commentary-content-card {
  border-radius: 8px;
  box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.08);
}

/* Save state chip styles */
.save-state-chip {
  font-weight: 600;
}

.save-state-chip__icon {
  margin-right: 4px;
}

.save-state-chip__text {
  line-height: 1;
}

/* Rejection target item styles */
.rejection-target-item {
  transition: background-color 0.2s ease;
}

.rejection-target-item:hover {
  background-color: rgba(244, 67, 54, 0.08);
  }
.height-20{
  height: 20px;
}
.grey-title{
  color: var(--grey-500, #828285);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
}
.actual-card{
  border-radius: var(--space-xs, 8px);
  background: var(--grey-50, #F7F7F7);
  padding: 10px;
}
</style>
